import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { OrderOverviewComponent } from './order-overview.component';
import { OrderInfoBlocksModule } from '../order-info-blocks/order-info-blocks.module';
import { CakeItEasyWebUiModule } from '@cakeiteasy/web-ui';
import { NgCakeItEasyUtilsModule } from '@cakeiteasy/web-utils';
import { NgBusyModule } from 'ng-busy';
import { TranslateModule } from '@ngx-translate/core';
import { UnifiedOrderInfoTableModule } from '../unified-order-info-table/unified-order-info-table.module';
import { OrderChatModule } from '../order-chat/order-chat.module';

@NgModule({
  imports: [
    CommonModule,
    CakeItEasyWebUiModule,
    NgCakeItEasyUtilsModule,
    NgBusyModule,
    TranslateModule,
    UnifiedOrderInfoTableModule,
    OrderChatModule,
    OrderInfoBlocksModule,
  ],
  exports: [
    OrderOverviewComponent,
  ],
  declarations: [
    OrderOverviewComponent,
  ]
})
export class OrderOverviewModule {
}
